import { render, staticRenderFns } from "./chartPriceIndexHistoryModal.vue?vue&type=template&id=12c0a4b8"
import script from "./chartPriceIndexHistoryModal.vue?vue&type=script&lang=js"
export * from "./chartPriceIndexHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports